// extracted by mini-css-extract-plugin
export default {"downloadBtn":"app__css__app-pages-reportSheetViewer-__index__downloadBtn"};